export default __webpack_public_path__ + "static/media/auth_set.48b937ac.svg";